import { YES_AND_NO } from '../../../../shared/constants';

export const YES_AND_NO_OPTIONS = [
  {
    label: YES_AND_NO.YES.label,
    value: YES_AND_NO.YES.value,
  },
  {
    label: YES_AND_NO.NO.label,
    value: YES_AND_NO.NO.value,
  },
];
